import React, { Component } from 'react';
import Shutter_On_Off from './Components/Shutter_On_Off';
import { getIcon } from '../../../Common/Common';
import { pushCommand, pushGroupCommand, isEmpty, addAnimation } from '../../../Common/Common';
import Error_Message from './Components/Error_Message';

export default class ShutterOperation extends Component {
	constructor(props) {
		super(props);
	}

	handleSendCommand = (command, val) => {
		// Check whether it is a point operation or group operation
		if (this.props.group_id != null) {
			pushGroupCommand(command, val, this.props.group_id);
		} else if (this.props.point_id != null) {
			this.target_id = this.props.point_id;
			pushCommand(command, val, this.props.point_id);
		}
	}
	handleRollerShutterOperation = (action) => {
		let elem = document.getElementById(action);
		addAnimation(elem, 'fadeIn', () => { }, 2000)
		let command = 'shutter';
		this.handleSendCommand(command, action);
	}

	render() {
		let error_message = '';
		let is_show_error_message = false;

		let icon = null;
		if (this.props.point_id != null && !isEmpty(this.props.point_info)) {
			icon = getIcon(this.props.point_info.icon, this.props.point_info.stat);

			if (this.props.point_info.error != null) {
				//check if device has device error
				let device_error = this.props.point_info.error;
				for (var key in device_error) {
					if (device_error[key]) {
						error_message = key;
						is_show_error_message = true;
					}
				}
			}
		}
		else if (this.props.group_id != null && !isEmpty(this.props.group_info)) {
			icon = getIcon(this.props.group_info.icon);
		}

		let icon_width = 150;


		let op_button_cell_style = {
			width: 80,
			height: 80,
			margin: 5,
			padding: 10,
			backgroundColor: 'white',
			borderRadius: 20,
			boxShadow: '0 0 3px rgba(0, 0, 0, 0.2)',
			fontSize: 11,
		}

		return (
			<div id='shutter_operation' >
				{/* If group operation, hide component */}
				{this.props.group_id == null ?
					<div>
						<div style={{ verticalAlign: 'top', marginTop: 20 }}>
						</div>
						{/* Icon */}
						<div>
							<img id={'device_icon'} src={icon} alt='icon' style={{ width: icon_width }} />
						</div>
					</div> : null}
				<div id='op_buttons' style={{ marginBottom: 10, marginTop: 20 }}>
					{/* Open Shutter Button */}
					<div id='open' style={{ cursor: 'pointer', display: 'inline-block', verticalAlign: 'top' }} onClick={() => { this.handleRollerShutterOperation('open') }}>
						<Shutter_On_Off
							style={op_button_cell_style}
							point_id={this.props.point_id}
							point_info={this.props.point_info}
							receiver={this.props.receiver}
							action={"open"}
						/>
					</div>
					{/* Close Shutter Button */}
					<div id='close' style={{ cursor: 'pointer', display: 'inline-block', verticalAlign: 'top' }} onClick={() => { this.handleRollerShutterOperation('close') }}>
						<Shutter_On_Off
							style={op_button_cell_style}
							point_id={this.props.point_id}
							point_info={this.props.point_info}
							receiver={this.props.receiver}
							action={"close"}
						/>
					</div>
				</div>
				{is_show_error_message ?
					<div id='error_message'>
						<Error_Message
							deviceErrorMessage={error_message}
						/>
					</div> : null}
			</div>
		)
	}
}